export const TOGGLE_ACCUMULATE_ASSETS = 'TOGGLE_ACCUMULATE_ASSETS';
